module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.7@readable-stream/lib/internal/streams/stream-browser.js
// module id = 324
// module chunks = 0